export var ShadowSnapshotType;
(function (ShadowSnapshotType) {
    ShadowSnapshotType["SHADOW_SNAPSHOT_TYPE_STORAGE_LAYER_V2"] = "STORAGE_LAYER_V2";
})(ShadowSnapshotType || (ShadowSnapshotType = {}));
